import { makeStyles, createStyles } from "@material-ui/core"

const useStyles = makeStyles(() => createStyles({
    root: {
        display:"flex",
        justifyContent:"flex-end"
    }
}))

export default useStyles